import styled from 'styled-components'

export const VehicleListWrapper = styled.div`
  position: relative;
  width: 100%;
`

VehicleListWrapper.displayName = 'VehicleListWrapper'
